<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="create()">Create Station</button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search Stations..."' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
</div>

<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable
    #packageTable
    class='material striped datatable'
    [rows]='display'
    [columnMode]='"force"'
    [headerHeight]='40'
    [sorts]="[{prop: 'id', dir: 'desc'}]"
    [footerHeight]='20'
    [scrollbarH]="true"
    [scrollbarV]="true"
    [rowHeight]="40"
    [reorderable]="true">

    <ngx-datatable-column prop="name" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Station Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="description" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Description
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.description}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Assigned
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.assigned ? 'Yes' : 'No'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Allow Guests
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.allowGuests ? 'Yes' : 'No'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateCreated" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Date Created
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.dateCreated | date:'EEEE, MMMM d, y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Location
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.location?.name}}
        </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span>
                Reader
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button *ngIf="!row.reader" container="body" placement="left" tooltip="No reader has been assigned to this station" style="color: white;"  class="btn btn-warning btn-icon"><i class="flaticon-warning-2"></i></button>
            <button tooltip="Details" *ngIf="row.reader" class="btn btn-success btn-icon" (click)="deviceDetails(row.reader)"><i class="flaticon-piggy-bank"></i></button>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span>
                Printer
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button *ngIf="!row.printer" container="body" placement="left" tooltip="No printer has been assigned to this station" style="color: white;" class="btn btn-warning btn-icon"><i class="flaticon-warning-2"></i></button>
            <button *ngIf="row.printer" tooltip="Details" class="btn btn-success btn-icon" (click)="deviceDetails(row.printer)"><i class="flaticon-file-1"></i></button>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="130" [maxWidth]="130">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button tooltip="Edit" class="btn btn-success btn-icon" (click)="edit(row.stationId)"><i class="flaticon-edit-1"></i></button>
            <button tooltip="Delete" class="btn btn-danger btn-icon" (click)="delete(row.stationId)"><i class="flaticon-cancel"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>
